import Vue from "vue";
import VueAnalytics from "vue-analytics";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPause, faPlay, faRedo, faLockOpen, faLock, faBell, faBellSlash, faBars, faTimes, faVolumeDown, faVolumeMute, faQuestionCircle, faMinus, faBroadcastTower } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import App from "./App.vue";
import "./registerServiceWorker";

import store from "@/store";

library.add(faPause, faPlay, faRedo, faLockOpen, faLock, faBell, faBellSlash, faBars, faTimes, faVolumeDown, faVolumeMute, faQuestionCircle, faMinus, faBroadcastTower);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;
// Vue.config.devtools = true;

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_API_KEY,
  integrations: [
    new VueIntegration({
      Vue,
      attachProps: true
    })
  ]
});

const isProd = process.env.NODE_ENV === "production";
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_ANALYTICS_ID,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
});

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
